import { ComponentProps } from 'react'
import styles from './styles.module.scss'

const Item = ({ className, ...props }: ComponentProps<'div'>) => (
  <div {...props} className={[styles.item, className].join(' ')} />
)

export default Item
